import React from 'react';

const OurPackageCard = ({ item, index }) => {
	return (
		<>
			<div className='box' data-aos='fade-up' key={index}>
				<div className='image'>
					<img src={item.image} alt='' />
					<h3>
						<i className='fas fa-map-marker-alt'></i> {item.title}
					</h3>
				</div>
				<div className='content'>
					<div className='price'>
						{item.discount} <span>{item.price}</span>
					</div>
					<p style={{ fontSize: 12, fontFamily: 'Poppins, sans-serif' }}>
						{item.desc}
					</p>
					<a href='#' className='btn'>
						Book Now
					</a>
				</div>
			</div>
		</>
	);
};

export default OurPackageCard;
